export enum ActivityType {
  CtrMessageSentRegulator = 68,
  CtrMessageSentAO = 69,
  CtrClosed = 70,
  CtrAssignedOfqual = 71,
  CtrAssignedCcea = 72
}
